import FeatureGates from '@atlaskit/feature-gate-js-client';

import { NOT_ENROLLED, RECOMMEND_TO_FREE_STATSIG_EXPERIMENT } from '../package-constants';

export const getCohortValue = () => {
	const cohort = FeatureGates.getExperimentValue<string>(
		RECOMMEND_TO_FREE_STATSIG_EXPERIMENT,
		'cohort',
		NOT_ENROLLED,
		{
			// Will not fire the exposure until modal is ready to be either viewed (test) or aborted (control)
			fireExperimentExposure: false,
		},
	);
	return cohort;
};
